import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';
import { AnswerResultFormModule } from '@new-core/components/game-forms/answer-result-form/answer-result-form.module';
import { AnswerEntryFormComponent } from '@new-core/components/inputs-gi/answer-entry-form/answer-entry-form.component';
import { GameInputComponent } from '@new-core/components/inputs-gi/game-input/game-input.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  AbacusModule,
  ButtonModule,
  CheckboxComponent,
  DefaultImageModule,
  FitTextModule,
  FormFieldModule,
  RectModule,
  TimerModule,
} from '@shared/components/games';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { ResultFormBgModule } from '../../../new-core/components/game-forms/result-form-bg/result-form-bg.module';
import { FlashCardsControllerComponent } from './flash-cards-controller/flash-cards-controller.component';
import { FlashCardsCorrectAnswerPreviewComponent } from './flash-cards-preview/flash-cards-answer-preview/flash-cards-answer-preview.component';
import { FlashCardsExamplePreviewComponent } from './flash-cards-preview/flash-cards-example-preview/flash-cards-example-preview.component';
import { FlashCardsParametersPreviewComponent } from './flash-cards-preview/flash-cards-parameters-preview/flash-cards-parameters-preview.component';
import { FlashCardsUserAnswerPreviewComponent } from './flash-cards-preview/flash-cards-user-answer-preview/flash-cards-user-answer-preview.component';
import { FlashCardsSettingsComponent } from './flash-cards-settings/flash-cards-settings.component';

@NgModule({
  declarations: [
    FlashCardsControllerComponent,
    FlashCardsSettingsComponent,
    FlashCardsCorrectAnswerPreviewComponent,
    FlashCardsExamplePreviewComponent,
    FlashCardsParametersPreviewComponent,
    FlashCardsUserAnswerPreviewComponent,
  ],
  exports: [
    FlashCardsControllerComponent,
    FlashCardsSettingsComponent,
    FlashCardsCorrectAnswerPreviewComponent,
    FlashCardsExamplePreviewComponent,
    FlashCardsParametersPreviewComponent,
    FlashCardsUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    DefaultImageModule,
    CalculatorModule,
    FormFieldModule,
    AbacusModule,
    FitTextModule,
    ButtonModule,
    TimerModule,
    RectModule,
    GameInputComponent,
    GameButtonComponent,
    ResultFormBgModule,
    AnswerEntryFormComponent,
    AnswerResultFormModule,
    GamesSharedModule,
  ],
})
export class FlashCardsModule {}
